module.exports = __webpack_public_path__ + "fonts/Rutan-Light.woff2";